import { render } from "./AttachTrailerConfirmation.vue?vue&type=template&id=21d50b48&ts=true"
import script from "./AttachTrailerConfirmation.vue?vue&type=script&lang=ts"
export * from "./AttachTrailerConfirmation.vue?vue&type=script&lang=ts"

import exportComponent from "/builds/knx-core/freightbox/freightbox-monorepo-vue/services/eleos-driver-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__